import type { LandingPageCardData } from '@/app/components/LandingPage/LandingPageCards/types';

export const hardwareEducationCardsData: LandingPageCardData[] = [
  {
    description: 'ring_pdp_2025_lifestyle_card_1_copy',
    id: 'ring_pdp_2025_card_1',
    image: {
      localizedAlt: 'man_exercise_alt',
      src: '/pdp/2025/hardware_section_card_1.jpg',
    },
  },
  {
    description: 'ring_pdp_2025_lifestyle_card_2_copy',
    id: 'ring_pdp_2025_card_2',
    image: {
      localizedAlt: 'hrm_or4_ring_silver_slide_1_alt',
      src: '/pdp/2025/hardware_section_card_2.jpg',
    },
  },
  {
    description: 'ring_pdp_2025_lifestyle_card_3_copy',
    id: 'ring_pdp_2025_card_3',
    image: {
      localizedAlt: 'experience_style_image_1_alt',
      src: '/pdp/2025/hardware_section_card_3.jpg',
    },
  },
];
